export default __webpack_public_path__ + "static/media/640_dummy2016-wellness01-de.9b06edeb.png";